import React from 'react';
export var HSBCLogo = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "data-testid": "hsbc-bank-logo",
    height: "24",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("title", {
    id: "hsbc-logo-title"
  }, title), React.createElement("defs", null, React.createElement("path", {
    d: "M4 0h316a4 4 0 014 4v92a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
    id: "hsbc-a"
  }), React.createElement("mask", {
    fill: "#fff",
    id: "hsbc-b"
  }, React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#hsbc-a"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-263-330H97v1850h-360z",
    fill: "#fff"
  }), React.createElement("g", {
    transform: "translate(-245 -6)"
  }, React.createElement("use", {
    fill: "#f5f7fa",
    xlinkHref: "#hsbc-a"
  }), React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#hsbc-b)"
  }, React.createElement("path", {
    d: "M280 6h-32c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V9c0-1.7-1.4-3-3-3z",
    fill: "#000",
    opacity: ".07"
  }), React.createElement("path", {
    d: "M280 7c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-32c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M253.803 14h7.59v7.589h-7.59z",
    fill: "#fff"
  }), React.createElement("g", {
    fill: "#db0011"
  }, React.createElement("path", {
    d: "M265.187 17.803L261.392 14v7.598zM257.598 17.803L261.392 14h-7.589zM250 17.803l3.803 3.795V14z"
  }), React.createElement("path", {
    d: "M257.598 17.803l-3.795 3.795h7.59z"
  })), React.createElement("path", {
    d: "M268.517 18.027h-1.375v1.357h-.688v-3.179h.688v1.304h1.375v-1.304h.687v3.179h-.687zM270.865 19.446c-.688 0-1.25-.277-1.26-1.036h.688c.01.34.206.545.58.545.277 0 .599-.143.599-.455 0-.25-.214-.322-.572-.429l-.232-.062c-.5-.143-1-.34-1-.911 0-.705.661-.946 1.26-.946.615 0 1.15.214 1.16.92h-.688c-.026-.286-.196-.456-.517-.456-.26 0-.51.134-.51.42 0 .232.215.303.661.446l.268.08c.545.17.893.357.893.893-.009.714-.705.991-1.33.991zM272.579 16.214h1.107c.205-.009.42 0 .625.036.384.09.678.34.678.768 0 .41-.258.616-.633.714.428.08.75.295.75.768 0 .723-.715.884-1.268.884h-1.25zm1.107 1.321c.304 0 .616-.062.616-.428 0-.33-.286-.42-.571-.42h-.482v.848zm.062 1.375c.322 0 .634-.071.634-.464s-.267-.464-.598-.464h-.544v.928zM276.891 19.446c-1.027 0-1.482-.652-1.482-1.625s.509-1.678 1.518-1.678c.634 0 1.25.285 1.268 1h-.715c-.035-.322-.25-.482-.553-.482-.625 0-.813.67-.813 1.178s.188 1.098.786 1.098c.313 0 .545-.17.59-.49h.714c-.072.731-.652 1-1.313 1z",
    fill: "#000"
  })))));
};
HSBCLogo.defaultProps = {
  title: 'HSBC'
};